module.exports = __webpack_public_path__ + "img/Privacy-Settings.3cf41010.png";